import {useState} from "react";
import {useDispatch} from 'react-redux';
import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

import {useCreateImpersonationMutation}  from "../../redux/services/impersonationApi";
import { useGetPatientsQuery } from "../../redux/services/patientApi";
import {startImpersonation} from '../../redux/reducers/auth';
import FindPatientForm from "../patients/FindPatientForm";

const handleImpersonate = ({create, impersonate, navigate}) => async (e, {userId}) => {
  const response = await create({userId});
  if (response?.data?.access) {
    impersonate({
      accessToken: response.data.access,
      refreshToken: response.data.refresh,
      user: response.data.user,
      email: response.data.email,
      deviceToken: response.data.device_token,
      deviceExp: response.data.expires_on,
    });
    navigate('/clients');
  }
};

const AssumePatientRoleForm = ({onSubmit}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [create] = useCreateImpersonationMutation();
  const impersonate = params => dispatch(startImpersonation(params));
  const patientQuery = useGetPatientsQuery({
    id: selectedPatientId,
    hide_details: true,
  }, {skip: !selectedPatientId});
  const patient = (patientQuery?.data?.data || []).find(p => p.id === selectedPatientId);
  const userId = patient?.user_id || patient?.user?.id;
  return (
    <Stack spacing={2}>
      <Typography variant="h2">Impersonate Patient</Typography>
      <FindPatientForm 
        allPatients={true}
        defaultValue={selectedPatientId}
        onSubmit={({patientId}) => setSelectedPatientId(patientId)}
      />
      {
        selectedPatientId && (
          <Stack>
            <Button
              variant='contained'
              disabled={!userId}
              onClick={e => handleImpersonate({create, impersonate, navigate})(e, {userId})}
            >
              Impersonate Patient
            </Button>
          </Stack>
      )}
    </Stack>
    );
  };

export default AssumePatientRoleForm;